<template>
  <section class="hero">
    <div class="hero-content">
      <h1>Bienvenue sur <strong>{{ settingsStore.appName }}</strong></h1>
      <p>Trouvez, réservez et payez vos tickets de transport facilement.</p>
      <div class="search-box-container">
        <SearchBox />
      </div>
    </div>
  </section>
  <div class="page-container">
    <div class="page-content">
      <Carousel v-if="latestTrips.length > 0" :settings="carouselSettings" :breakpoints="carouselBreakpoints"
        :autoplay="3000" :pause-autoplay-on-hover="true" :wrapAround="true" class="carousel-container-trips">
        <Slide v-for="trip in latestTrips" :key="trip.id">
          <TripCardCarousel :trip="trip" />
        </Slide>
        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </Carousel>
      <EmptyState v-else variant="caroussel" />

      <article>
        <img src="../assets/images/undraw_the-search_cjxa.png" alt="Search Info Image" />
        <div class="text">
          <h2>🔍 Recherche simplifié</h2>
          <p>Plus besoin de vous déplacer en agence ou de multiplier les appels pour connaître les horaires. Avec
            <strong>{{
              settingsStore.appName }}</strong>, planifier un déplacement devient un jeu d'enfant. Saisissez votre ville
            de
            départ et de destination pour consulter instantanément les compagnies disponibles, les véhicules et les
            horaires
            de départ et d'arrivée. Comparez les options, vérifiez les disponibilités en temps réel, et faites le
            meilleur
            choix pour votre trajet. Appuyez-vous également sur les évaluations de la communauté pour choisir la
            compagnie la
            plus fiable. Gagnez un temps précieux en organisant votre départ depuis votre canapé.
          </p>
        </div>
      </article>
      <article>
        <img src="../assets/images/undraw_transfer-money_h9s3.png" alt="Payment Info Image" />
        <div class="text">
          <h2>💳 Paiment Sécurisé</h2>
          <p>Sécurisez votre voyage avant même le jour du départ. Notre plateforme vous permet d'acheter vos billets en
            ligne
            grâce à un système de paiement rapide et fiable. Que vous prépariez votre trajet à l'avance ou à la dernière
            minute, validez votre place en quelques clics. Votre réservation est instantanément confirmée et enregistrée
            dans
            notre système, vous garantissant ainsi un départ sans mauvaise surprise.</p>
        </div>
      </article>
      <article>
        <img src="../assets/images/undraw_wallet_diag.png" alt="eTicket Info Image" class="img-max-width" />
        <div class="text">
          <h2>🎫 Carnet de eTiket</h2>
          <p>Fini le stress du ticket papier perdu, oublié ou abîmé ! Dès l'achat, votre billet est généré sous forme
            numérique et conservé en toute sécurité dans l'application. Ce e-Ticket officiel fait office de preuve
            d'achat et
            permet une vérification rapide par le chauffeur au moment de l'embarquement. Vous pouvez consulter à tout
            moment
            l'ensemble de vos billets actuels et votre historique de voyage directement depuis votre compte.</p>
        </div>
      </article>
    </div>
  </div>
</template>

<script setup>
import SearchBox from '@/components/SearchBox.vue'
import 'vue3-carousel/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import { ref, nextTick, onMounted } from 'vue'
import { config } from '@/config/env.js'
import TripCardCarousel from '@/components/TripCardCarousel.vue'
import { useSettingsStore } from '@/stores/settingsStore'
import EmptyState from '@/components/EmptyState.vue'

const settingsStore = useSettingsStore()

const latestTrips = ref([])

const carouselSettings = {
  itemsToShow: 1,         // mobile : 1 slide
  snapAlign: 'start',
  mouseWheel: false,
}

const carouselBreakpoints = {
  640: {
    itemsToShow: 2,       // tablette : 2 slides
    snapAlign: 'start',
  },
  1024: {
    itemsToShow: 3,       // desktop : 3 slides
    snapAlign: 'start',
  },
}

const wrapAround = ref(false)

async function loadLatestTrips() {
  try {
    const response = await fetch(config.apiUrl + '/trips/latest')
    if (!response.ok) throw new Error('Impossible de charger les derniers trajets')
    const data = await response.json()
    latestTrips.value = Array.isArray(data) ? data.slice(0, 6) : []
  } catch (e) {
    console.error('Erreur lors du chargement des derniers trajets:', e)
    latestTrips.value = []
  }
}

onMounted(async () => {
  await loadLatestTrips()
  await nextTick()
  wrapAround.value = true
})
</script>
<style scoped>
.page-container {
  padding: 2rem 2rem 5rem;
}

.page-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  gap: 4rem;
}

.page-content article {
  max-width: 80%;
}

@media (max-width: 768px) {
  .page-content {
    gap: 3rem;
  }

  .page-container {
    padding: 0 1.5rem 2rem;
  }

  .page-content article {
    max-width: 100%;
  }

}
</style>
